import { Link } from 'react-router-dom';
import forgotPassword from '../../assets/images/icons/forgotPassword.svg';
import logo from '../../assets/images/Logo.svg';
import Button from '../../components/Button';
import { ButtonContainer } from '../../components/Form';
import FormGroup from '../../components/FormGroup';
import Input from '../../components/Input';
import Loader from '../../components/Loader';
import { Container } from './styles';

import Transitions from '../../components/Transition';
import useResetPassword from './useResetPassword';

export default function ResetPassword() {
  const {
    isLoading,
    getErrorMessageByFieldName,
    password,
    handlePasswordChange,
    passwordConfirmation,
    handlePasswordConfirmationChange,
    resetPassword,
    isReadyToResetPassword,
  } = useResetPassword();

  return (
    <Transitions>
      <Loader isLoading={isLoading} />
      <Container>
        <div className="asideGif">
          <img src={forgotPassword} alt="busGif" />
        </div>

        <div className="asideLogin">
          <div className="loginTitle">
            <div className="labelTitle">
              <div>
                Alteração de senha
              </div>
              <div className="subtitle">
                Defina sua nova senha
              </div>
            </div>
            <img src={logo} alt="logo" className="logo" />
          </div>

          <div className="loginForm">
            <div className="loginInput">
              <FormGroup error={getErrorMessageByFieldName('password')}>
                <label htmlFor="login">Senha</label>
                <Input
                  placeholder="********"
                  value={password}
                  onChange={handlePasswordChange}
                  autoComplete="new-password"
                  error={getErrorMessageByFieldName('password')}
                  type='password'
                />
              </FormGroup>

              <FormGroup error={getErrorMessageByFieldName('passwordConfirmation')}>
                <label htmlFor="login">Confirme a Senha</label>
                <Input
                  type="password"
                  placeholder="******"
                  value={passwordConfirmation}
                  onChange={handlePasswordConfirmationChange}
                  error={getErrorMessageByFieldName('passwordConfirmation')}
                  autoComplete="new-password"
                />
              </FormGroup>
            </div>
          </div>

          <ButtonContainer flexDirection="column">
            <Button type="button" onClick={resetPassword} disabled={!isReadyToResetPassword}>
              Confirmar alteração de senha
            </Button>
            <div className="backToLogin">
              <Link to="/">Realizar login</Link>
            </div>
          </ButtonContainer>
        </div>
      </Container>
    </Transitions>
  );
}
